import cloneDeep from 'lodash/cloneDeep';
import { PartialReport, Report } from '../../../reporter/report/Report';
import PendingReport from './PendingReport';

const updateInitialReportFromRecord = (
  init: PartialReport,
  record: PartialReport
): void => {
  // report is a throw away object that contains the merged ecdn11
  const report = new PendingReport();
  report.mergeData([init as Report, record as Report]);
  if (report.ecdn11) {
    init.ecdn11 = report.ecdn11;
    // We don't want to send the content.
    init.ecdn11.content = undefined;
  }
  if (record.localityData) {
    init.localityData = record.localityData;
  }
  if (record.general) {
    const general = record.general as unknown as Record<string, unknown>;
    const initGeneral = init.general as unknown as Record<string, unknown>;
    [
      'config',
      'playGuid',
      'playType',
      'playback',
      'title',
      'browserUserGuid',
      'artGuid',
      'integration',
      'o365',
      'localities',
      'labels'
    ].forEach(name => {
      if (general[name]) {
        initGeneral[name] = cloneDeep(general[name]);
      }
    });
  }
};

interface MergeArgs {
  from: Report;
  into: Report;
}

const mergeInInitialReport = (args: MergeArgs): void => {
  const { from: initialReport, into: record } = args;
  const report = new PendingReport();
  report.mergeData([initialReport, record]);
  record.ecdn11 = report.ecdn11;
  record.general = report.general;
  updateInitialReportFromRecord(initialReport, report);
};

export { mergeInInitialReport, updateInitialReportFromRecord };
